module.exports = __webpack_public_path__ + "img/chr_ts_90_4.f76a398d.png";